import { post } from '../axios'
const itemGroup = {
	// 删除重复组
	deleteGroup: params => post('/web/formData/deleteRepeatGroupFormData', params),
	// 新增/修改 重复组
	setGroup: params => post('/web/formData/saveOrUpdateRepeatGroupFormData', params)
}
export default itemGroup